export const getInitialState = () => ({
	domain: {},
	generalErrors: []
});
